<h1 mat-dialog-title>Select a Location</h1>
<div mat-dialog-content>
  <app-search-location (locationSelected)="onLocationSelected($event)"></app-search-location>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
</div>